module.exports = __webpack_public_path__ + "static/media/comp-grinding-s.dea216d5.webp";